import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=791587c4"
import script from "./FilterItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports